module.exports = __webpack_public_path__ + "static/media/pexels-photo-3747505.b5c4a023.svg";